import { createFileRoute, Link } from '@tanstack/react-router';

function PostEditPage() {
  const { postId } = Route.useParams();
  return (
    <div>
      <h1 style={{ marginBottom: '10px', color: '#333', fontSize: '1.5rem' }}>
        Nested Dynamic Route: Edit Post {postId}
      </h1>
      <p style={{ marginBottom: '15px', color: '#666', fontSize: '14px' }}>
        동적 세그먼트 아래에 중첩된 추가 경로입니다. /posts/$postId/edit 형태로 매칭됩니다.
      </p>
      <Link to="/posts/$postId" params={{ postId }} style={{ color: '#0066cc' }}>
        ← Post {postId}로
      </Link>
    </div>
  );
}

export const Route = createFileRoute('/sample/posts/$postId/edit')({
  component: PostEditPage,
});

